const animationContactFormEffect = () => {
	const container = document.querySelector('.contact-form-container');

	if (!container) {
		return;
	}

	const title = container.querySelector('h3'),
		form = container.querySelectorAll('form'),
		button = container.querySelectorAll('form .button');

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: container,
			start: 'top+=10% bottom',
			once: true,
			//markers: true,
		},
	});

	tl.from(container, {
		duration: 0.6,
		autoAlpha: 0,
		ease: 'power1.out',
	})
		.from(
			title,
			{
				duration: 0.3,
				autoAlpha: 0,
				y: 40,
				ease: 'power2.in',
			},
			'>-=0.2'
		)
		.from(
			form,
			{
				duration: 0.3,
				autoAlpha: 0,
				y: 40,
				ease: 'none',
			},
			'>-=0.1'
		)
		.from(
			button,
			{
				duration: 0.25,
				autoAlpha: 0,
				x: +150,
				ease: 'none',
			},
			'>+=2'
		);

	return tl;
};

export default animationContactFormEffect;
